import { Button, Modal } from "@mantine/core";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { generatePath } from "react-router";
import { ModalFooter } from "../../../mantine/components/ModalFooter/ModalFooter";
import { useToast } from "../../../mantine/notifications/useToast";
import { ROUTES } from "../../../routes";
import urls from "../../../urls";
import type { Person, Todo, User } from "../../../utils/backend-types";
import { TodoForm } from "../TodoForm/TodoForm";
import type { Mode } from "../Todos.types";
import "./NewTotalModal.scss";

interface NewTodoModalProps {
  basePath: string;
  isOpen: boolean;
  mode: Mode;
  persons: Array<Person>;
  projectId: string;
  users: Array<User>;
  variantId: number;
  onToggle: () => void;
}

function NewTodoModal({
  basePath,
  isOpen,
  mode,
  persons,
  projectId,
  users,
  variantId,
  onToggle
}: NewTodoModalProps) {
  const { showToast } = useToast();
  const queryClient = useQueryClient();
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleSubmit(data: Todo) {
    if (basePath !== ROUTES.todos.entry) {
      document.location.href = `${generatePath(basePath, {
        projectId: projectId
      })}/${data.id}/`;
    } else {
      await queryClient.invalidateQueries({
        queryKey: ["todos"]
      });
      onToggle();
      showToast({
        type: "success",
        message: "Die Aufgabe wurde erfolgreich erstellt."
      });
    }
  }

  const postUrl = urls.api.todosCreate();

  return (
    <Modal
      className="NewTodoModal"
      opened={isOpen}
      size="lg"
      title="Aufgabe hinzufügen"
      onClose={onToggle}
    >
      <TodoForm
        mode={mode}
        persons={persons}
        postUrl={postUrl}
        users={users}
        variantId={variantId}
        onSubmit={handleSubmit}
        onSubmittingChange={setIsSubmitting}
      />
      <ModalFooter>
        <Button variant="default" onClick={onToggle}>
          Abbrechen
        </Button>
        <Button
          color="secondary"
          form="todo-form"
          loading={isSubmitting}
          type="submit"
        >
          Erstellen
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export { NewTodoModal };
